import { SxProps, Theme } from '@mui/material';

interface Styles {
  paper: SxProps<Theme>;
  header: SxProps<Theme>;
  subtitle: SxProps<Theme>;
  form: SxProps<Theme>;
  button: SxProps<Theme>;
  backButton: SxProps<Theme>;
  alert: SxProps<Theme>;
  successMessage: SxProps<Theme>;
}

export const styles: Styles = {
  paper: {
    marginTop: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 3,
    borderRadius: 2,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 2,
  },
  subtitle: {
    marginTop: 1,
    textAlign: 'center',
  },
  form: {
    width: '100%',
    marginTop: 1,
  },
  button: {
    marginTop: 2,
    marginBottom: 2,
    height: 40,
  },
  backButton: {
    marginTop: 1,
    textTransform: 'none',
  },
  alert: {
    width: '100%',
    marginBottom: 2,
  },
  successMessage: {
    width: '100%',
    marginTop: 2,
    display: 'flex',
    flexDirection: 'column',
  },
};
